import $ from 'jquery';
import ScrollMagic from 'ScrollMagic';
import Scrollbar from 'smooth-scrollbar';
import 'debug.addIndicators';

export default () => {

    var isMobile = $('body').attr('data-is-mobile');
    //console.log('isMobile: ' + isMobile);
    //console.log('window: ' + $(window).width());

    if (isMobile == "false") {
        if ($(window).width() > 768) {
            //console.log('scroll scrollmagic');
            // init controller
            var controller = new ScrollMagic.Controller({
                refreshInterval: 0
            })
            // init scrollbar
            var elem = document.querySelector("#scroll-content");
            //var scrollbar = Scrollbar.init(elem);

            var $headerHeight = $('header').height();
            var url_default = $('.header__logo').attr('data-url-default');
            var url_collapsed = $('.header__logo').attr('data-url-collapsed');

            var sceneHeader = new ScrollMagic.Scene({
                 triggerElement: 'header', 
                 offset: '-20px',
                 duration: '100px'
                })
                //.addIndicators()
                .addTo(controller);

            sceneHeader.triggerHook(0);

            sceneHeader.on('enter', function () {
                $('header').removeClass('collapsed');
                $('body').removeClass('header-collapsed');
                if ($('header').attr('class').indexOf('overlay-open') === -1) {
                    $('.header__logo').attr('src', url_default);
                }
            });

            sceneHeader.on('leave', function (event) {
                $('header').addClass('collapsed');
                $('body').addClass('header-collapsed');
                $('#main-content').addClass('collapsed');
                $('.header__logo').attr('src', url_collapsed);
            });

            //scrollbar.addListener(() => {
            //    sceneHeader.refresh()
            //})
        } else {
            scrollNormal();
        }
    } else {
        scrollNormal();
    }


    function scrollNormal() {

        //console.log('scroll normal');
        $(window).on('scroll', function () {
            //console.log("I'm scrolling");
            //collapsed header on mobile
            var url_default = $('.header__logo').attr('data-url-default');
            var url_collapsed = $('.header__logo').attr('data-url-collapsed');
            var scroll = $(window).scrollTop();
            if (scroll > 150) {
                $('header').addClass('collapsed');
                $('body').addClass('header-collapsed');
                $('.header__logo').attr('src', url_collapsed);
                $('#main-content').addClass('collapsed');
            } else {
                $('#main-content').removeClass('collapsed');
                $('header').removeClass('collapsed');
                $('body').removeClass('header-collapsed');
                if ($('header').attr('class').indexOf('overlay-open') === -1) {
                    $('.header__logo').attr('src', url_default);
                }
            }
        });
    }
};



// WEBPACK FOOTER //
// ./scripts/libs/smooth-scroll.js